import { useHoveredTs } from '../../../components/focus/hovered-ts-ctx';
import { StreamThumbnail } from './StreamThumbnail';
import { useActiveStation } from '../../../../../../../core/stations/hooks/useActiveStation';

export function HoveredThumbnail() {
  const ts = useHoveredTs();
  const stationId = useActiveStation().id;

  if (!ts) {
    return null;
  }

  return <StreamThumbnail stationId={stationId} ts={ts} />;
}
